<template>
    <c-dialog ref="dialog" title="团队成员管理" width="600" @resolve="submitHandle">
        <c-tips>不能移除负责人和已出发的成员</c-tips>
        <c-form ref="form" vertical unit-width="100%">
            <c-transfer ref="memberSelect" :title="['可选成员', '已选成员']" :value-data="selectedMembers" :disable-options="disabledMembers" async search @search="searchHandle"></c-transfer>
        </c-form>
    </c-dialog>
</template>

<script>
    import {mapState} from 'vuex'

	export default {
        name: 'aftersaleOrderMember',

		data() {
			return {
                order_id:0,
                order_status:0,                 //申请单状态 0-草稿，1-已提交（待派单），2-待处理（已待派单），3-处理中，4-已完成（待验收），5-已验收，10-已取消
                schedule_start_time:'',         //工单派单时间（未派单则无数据）
                selectedMembers: [],
                disabledMembers: []
			}
		},

		computed: {
			...mapState(['orderMemberStatusDic']),
		},
		
		methods: {
            open(data) {
                this.order_id = data.id;
                this.order_status = data.status;
                this.schedule_start_time = data.schedule_start_time;
                this.selectedMembers = [];
                this.disabledMembers = [];
                this.request({
                    url:'/after/sale/order/detail/member/list',
                    data: {
                       order_id: this.order_id,
                       sort_type: 'charge_status'
                    }
                }).then(data => {
                    this.selectedMembers = data.data.map(item => {
                        return {
                            value: item.user_id,
                            name: item.user_realname + (item.is_charge == 2 ? '(负责人)' : (item.status != 0 ? `(${this.orderMemberStatusDic.find(status => status.value == item.status).name})` : '')),
                            data: item
                        }
                    });
                    this.disabledMembers = data.data.filter(item => item.is_charge == 2 || item.status != 0).map(item => item.user_id);
                });
                this.$refs.dialog.open();
            },

            searchHandle(keyword, resolve) {
                this.request({
                    url:'/system/options',
                    data: {
                        options_code: 'SYSUSER',
                        is_engineer: 1,
                        keyword
                    },
                    success:data => {
                        resolve(data);
                    }
                })
            },
            
            submitHandle(stop, next) {
                if (this.order_status == 2 && this.schedule_start_time) {
                    //查询工单排期时间是否存在冲突
                    this.request({
                        url: '/after/sale/order/dispatch/conflict',
                        data: {
                            order_id: this.order_id,
                            member_user_ids: this.$refs.memberSelect.get()
                        },
                        loading: true,
                        success: (data, message) => {
                            if (data == 1) {
                                this.$confirm({
                                    type: 'warn',
                                    title: '排期冲突',
                                    message,
                                    buttonName: '继续修改',
                                    cancelButtonName: '取消修改',
                                    resolve: () => {
                                        this.dealSubmitHandle(stop,next);
                                    }
                                })
                            } else {
                                this.dealSubmitHandle(stop,next);
                            }
                        }
                    });
                } else {
                    this.dealSubmitHandle(stop, next);
                }
            },

            dealSubmitHandle(stop, next) {
                stop();
                this.$refs.form.submit({
                    url: '/after/sale/order/edit_member',
                    dataFormatter: data => {
                        data.order_id = this.order_id
                        data.member_list = this.$refs.memberSelect.get();
                        return data;
                    },
                    success: () => {
                        next();
                        this.$message({
                            message: '操作成功'
                        });
                        this.$emit('resolve');
                    }
                });
            }
		}
	}
</script>

<style lang="stylus" scoped>
</style>